import { useEffect, useState } from "react";
import axios from "axios";
import TPC_URL from "../../../utils/TPC_URL";

export const useMachineViewerData = (group_code, project_code) => {
  const [loading, setLoading] = useState(false);
  const [equipment, setEquipment] = useState([]);
  const [updateStatus, setUpdateStatus] = useState(false);
  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        const res = await axios.get(
          TPC_URL +
            `/api/mch/getLocalMachine?group_code=${group_code}&project_code=${project_code}`
        );
        const machineData = res.data.map((item) => {
          if (
            item.aps_machine_name &&
            item.machine_name !== item.aps_machine_name
          ) {
            return {
              ...item,
              id: item.machine_id,
              name: item.aps_machine_name,
              original_name: item.machine_name,
              inOperation: true,
            };
          }
          return {
            ...item,
            id: item.machine_id,
            name: item.machine_name,
            inOperation: true,
            original_name: null,
          };
        });

        setEquipment(machineData);
        if (updateStatus) {
          setUpdateStatus(false);
        }
      } catch (e) {
        console.log(e);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [updateStatus]);
  return { loading, equipment, setUpdateStatus, updateStatus };
};
